// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AddClassToSelectorOnConnectController from './add_class_to_selector_on_connect_controller'
import ActionOnEventController from './action_on_event_controller'
import AllFieldsRequiredToEnableElementController from './all_fields_required_to_enable_element_controller'
import AppendTextController from './append_text_controller'
import AsyncFetchMultipleComponentController from './async_fetch_multiple_component_controller'
import AutoResizeTextAreaController from './auto_resize_text_area_controller'
import CloudflareTurnstileController from './cloudflare_turnstile_controller'
import ClipboardController from './clipboard_controller'
import DisableFormOnSubmitController from './disable_form_on_submit_controller'
import DispatchEventOnActionController from './dispatch_event_on_action_controller'
import DispatchEventOnConnectController from './dispatch_event_on_connect_controller'
import DropdownController from './dropdown_controller'
import DropdownFormSubmitController from './dropdown_form_submit_controller'
import DropdownSelectController from './dropdown_select_controller'
import EditInteractionController from './edit_interaction_controller'
import HelloController from './hello_controller'
import IframeEventEmitterController from './iframe_event_emitter_controller'
import IframeEventHandlerController from './iframe_event_handler_controller'
import ImageFallbackController from './image_fallback_controller'
import ImageLoaderController from './image_loader_controller'
import NavigationDrawerController from './navigation_drawer_controller'
import MasonryController from './masonry_controller'
import ModalController from './modal_controller'
import OverflowListItemsController from './overflow_list_items_controller'
import PollEndpointController from './poll_endpoint_controller'
import ProgressBarController from './progress_bar_controller'
import QueryConfigComponentController from './query_config_component_controller'
import RadioButtonController from './radio_button_controller'
import ReadMoreController from './read_more_controller'
import RemoveElementAfterDelayController from './remove_element_after_delay_controller'
import RequestOnConnectController from './request_on_connect_controller'
import RevealElementsAfterIntervalController from './reveal_elements_after_interval_controller'
import SendEmailVerificationButtonController from './send_email_verification_button_controller'
import ScrollToElementController from './scroll_to_element_controller'
import SetControllerConnectedStatusController from './set_controller_connected_status_controller'
import SignInController from './sign_in_controller'
import SubmitCheckedElementsController from './submit_checked_elements_controller'
import SuggestPositionTitlesComponentController from './suggest_position_titles_component_controller'
import ToastInsertionController from './toast_insertion_controller'
import ToggleChildCheckboxesController from './toggle_child_checkboxes_controller'
import TypeaheadSearchController from './typeahead_search_controller'

// Stimulus Component Unextended Controllers
import Carousel from '@stimulus-components/carousel'
import Reveal from '@stimulus-components/reveal'
import Flatpickr from 'stimulus-flatpickr'
import Popover from '@stimulus-components/popover'

application.register('add-class-to-selector-on-connect', AddClassToSelectorOnConnectController)
application.register('action-on-event', ActionOnEventController)
application.register('all-fields-required-to-enable-element', AllFieldsRequiredToEnableElementController)
application.register('async-fetch-multiple-component', AsyncFetchMultipleComponentController)
application.register('append-text', AppendTextController)
application.register('auto-resize-text-area', AutoResizeTextAreaController)
application.register('carousel', Carousel)
application.register('cloudflare-turnstile', CloudflareTurnstileController)
application.register('clipboard', ClipboardController)
application.register('disable-form-on-submit', DisableFormOnSubmitController)
application.register('dispatch-event-on-action', DispatchEventOnActionController)
application.register('dispatch-event-on-connect', DispatchEventOnConnectController)
application.register('dropdown', DropdownController)
application.register('dropdown-form-submit', DropdownFormSubmitController)
application.register('dropdown-select', DropdownSelectController)
application.register('edit-interaction-form', EditInteractionController)
application.register('flatpickr', Flatpickr)
application.register('hello', HelloController)
application.register('iframe-event-emitter', IframeEventEmitterController)
application.register('iframe-event-handler', IframeEventHandlerController)
application.register('image-fallback', ImageFallbackController)
application.register('image-loader', ImageLoaderController)
application.register('navigation-drawer', NavigationDrawerController)
application.register('masonry', MasonryController)
application.register('modal', ModalController)
application.register('overflow-list-items', OverflowListItemsController)
application.register('poll-endpoint', PollEndpointController)
application.register('popover', Popover)
application.register('progress-bar', ProgressBarController)
application.register('query-config-component', QueryConfigComponentController)
application.register('radio-button', RadioButtonController)
application.register('read-more', ReadMoreController)
application.register('remove-element-after-delay', RemoveElementAfterDelayController)
application.register('request-on-connect', RequestOnConnectController)
application.register('reveal', Reveal)
application.register('reveal-elements-after-interval', RevealElementsAfterIntervalController)
application.register('scroll-to-element', ScrollToElementController)
application.register('send-email-verification-button', SendEmailVerificationButtonController)
application.register('set-controller-connected-status', SetControllerConnectedStatusController)
application.register('sign-in', SignInController)
application.register('submit-checked-elements', SubmitCheckedElementsController)
application.register('suggest-position-titles-component', SuggestPositionTitlesComponentController)
application.register('toast-insertion', ToastInsertionController)
application.register('toggle-child-checkboxes', ToggleChildCheckboxesController)
application.register('typeahead-search', TypeaheadSearchController)
